import React, { useEffect, useState } from "react";
import back1 from "../../assets/images/firstPage.JPG";
import { useIntl } from "react-intl";

const FirstPage = ({ homeSectionRef }) => {
  const [isVisible, setIsVisible] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true); // Set visibility to true when the section is in view
        }
      },
      { threshold: 0.1 } // Trigger when at least 10% of the section is visible
    );

    if (homeSectionRef?.current) {
      observer.observe(homeSectionRef.current);
    }

    return () => {
      if (homeSectionRef?.current) {
        observer.unobserve(homeSectionRef.current);
      }
    };
  }, [homeSectionRef]);

 
  return (
    <header>
      <div
        className="relative h-80 sm:h-96 md:h-screen lg:h-screen overflow-hidden bg-cover bg-no-repeat p-8 sm:p-12 text-center"
        style={{
          backgroundImage: `url(${back1})`, // Use local image here
        }}
        ref={homeSectionRef}
      >
        <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-gray-950/40 bg-fixed">
          <div className="flex h-full items-center justify-center">
            <div className="text-white w-full">
              {/* Heading with responsive text size and margin */}
              <h2 className="relative z-10 text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-black text-center mb-6 sm:mb-10 md:mb-12 lg:mb-16 mt-16">
                <span className="text-red-500">B</span>
                <span className="text-white">udai </span>
                <span className="text-red-500">R</span>
                <span className="bg-gradient-to-r text-white bg-clip-text text-transparent">
                  ally
                </span>
                <span className="text-red-500"> A</span>
                <span className="text-white">cademy</span>
                <span className="text-red-500">.</span>
              </h2>

              {/* Three text sections below the title */}
              <div className="w-full text-center mt-6 sm:mt-10 md:mt-12 lg:mt-16">
                <div className="space-y-4 text-base sm:text-xl md:text-2xl lg:text-3xl  lg:ml-[1000px]">
                  <p className="font-semibold first-letter:text-red-500 first-letter:text-5xl sm:first-letter:text-4xl">
                    {intl.formatMessage({ id: "firstPage.question1" })}
                  </p>
                  <p className="font-semibold first-letter:text-red-500 first-letter:text-5xl sm:first-letter:text-4xl">
                    {intl.formatMessage({ id: "firstPage.question2" })}
                  </p>
                  <p className="font-semibold first-letter:text-red-500 first-letter:text-5xl sm:first-letter:text-4xl">
                    {intl.formatMessage({ id: "firstPage.answer1" })}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default FirstPage;
